import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
const perks = ['Instant download', 'One-time payment', 'Lifetime access', '7-day guarantee', 'No subscription'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-ink-950 px-4 py-16 sm:px-6 sm:py-24" data-id="element-92" data-mp="15cu7mdad49f0">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-[360px] w-[360px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-lime/15 blur-[130px]" data-id="element-93" data-mp="1jclgy0pxp1mo" />
      <div className="relative mx-auto w-full max-w-xl text-center" data-id="element-94" data-mp="1t37tfm2ctc15">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-lime sm:text-xs" data-id="element-95" data-mp="1o3v6l1bhg4yk">
          Last call
        </p>
        <h2 className="mt-3 font-display text-2xl leading-tight text-white sm:text-4xl" data-id="element-96" data-mp="223365vbk5f3a">
          Your next aligner case is already coming
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-97" data-mp="1x2gn6qxe99wp">
          The question is whether you’ll approach it the same way… or with a system designed to help
          you identify potential problems before they become refinements.
        </p>

        <div className="mt-8 rounded-3xl border border-lime/30 bg-ink-900 p-6" data-id="element-98" data-mp="x2z9850bhoz5">
          <p className="font-display text-lg text-white sm:text-2xl" data-id="element-99" data-mp="123537ru27nke">Anti-Refinement System™</p>
          <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-lime sm:text-sm" data-id="element-100" data-mp="1658hspc0z89w">
            Reduce refinements. Increase predictability. Treat with confidence.
          </p>

          <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.16em] text-white/60" data-id="element-101" data-mp="1ftqfgxp0cz9b">
            Get instant access for just
          </p>
          <p className="font-display text-5xl leading-none text-lime sm:text-6xl" data-id="element-102" data-mp="1ksl5ajle7o2x">$27 USD</p>
          <p className="mt-2 text-xs text-white/55" data-id="element-103" data-mp="1pu0pk9fqxqk9">
            Currency conversion is automatic — you pay in your local currency.
          </p>

          <ul className="mx-auto mt-5 flex max-w-sm flex-wrap justify-center gap-2" data-id="element-104" data-mp="3qufels0efot7">
            {perks.map(perk => <li key={perk} className="flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 text-[11px] font-semibold text-white/75" data-id="element-105" data-mp="3lwndq8hs0scv">
                <CheckIcon className="h-3.5 w-3.5 text-lime" data-id="element-106" data-mp="3uupm593uana6" /> {perk}
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-107" data-mp="dhvkqxlndvuf">
            <CtaButton label="Get the Anti-Refinement System™" data-id="element-108" data-mp="8gy26jwq6zse" />
          </div>

          <div className="mt-6" data-id="element-109" data-mp="8j22yszbviog">
            <CountdownTimer data-id="element-110" data-mp="mgqq67gvb1wo" />
          </div>
        </div>

        <p className="mt-8 text-sm font-semibold leading-relaxed text-white/70" data-id="element-111" data-mp="me4kyehg8yhm">
          Stop waiting for the refinement to tell you something went wrong.
          <br data-id="element-112" data-mp="2o8lnfi2dn3vd" />
          <span className="text-lime" data-id="element-113" data-mp="2o8c4ufjnvyzp">Start looking for the problem before it gets there.</span>
        </p>
      </div>
    </section>;
}